import { Effected } from "@Shared/Entities/Supplier/Response/Proposal/enums";
import GetTotalOobCost from "@Shared/Helpers/CalculateUsageCovered/GetTotalOobCost";
import GetTotalTariffCost from "@Shared/Helpers/CalculateUsageCovered/GetTotalTariffCost";
export default (tender, proposal) => {
    const totalTariffCost = GetTotalTariffCost(proposal.get(Effected.TariffComponents));
    const totalOobCost = GetTotalOobCost(tender, proposal);
    const atc = proposal.get(Effected.Discount);
    return totalTariffCost + totalOobCost - atc;
};
